/**
 * 统一存放 localStorage key 避免重复
 */

export const CONSULT_IMPROVE_DIALOG_KEY = 'consult_improve_dialog_key';

// 咨询流量提升攻略弹窗：记录上次自动弹出的时间戳，命中人群 7 日内只自动弹一次
export const TRAFFIC_BOOST_POPUP_KEY = 'traffic_boost_popup_last_shown';